import CrmContactSession from "./model-session";
import CollectionProto from "../../../../data-structures/depricated/collection-proto";

export default class CrmContactCollectionSession extends CollectionProto {
    constructor(models) {
        super(models, CrmContactSession);
    }

    getContactsByAccountId = (crmAccountId) => {
        const models = _(this._models)
            .filter(model => model.crmAccountId === crmAccountId)
            .value();

        return new CollectionProto(models);
    }

    getCustomersByAccountId = (crmAccountId) => {
        const models = _(this._models)
            .filter(model => model.crmAccountId === crmAccountId && !!model.userId)
            .value();

        return new CollectionProto(models);
    }

    getCustomerByUserId = (userId) => {
        return _.find(this._models, model => model.userId === userId);
    }

    exportToOptions() {
        return _.map(this._models, model=>{
            return {
                label   : model.name,
                value   : model.id
            }
        })
    }
    
}
